import { render, staticRenderFns } from "./CreateProjectUpdate.vue?vue&type=template&id=b7cc3244&"
import script from "./CreateProjectUpdate.vue?vue&type=script&lang=js&"
export * from "./CreateProjectUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports